import { LinearProgress, SxProps, Theme } from "@mui/material";
import { GridPaginationModel } from "@mui/x-data-grid-pro";
import { SkeletonLoadingOverlay } from "components/SmDataGrid/SMDataGridSkeleton";
import { playerPageDateFormat } from "constants/dateFormat";
import moment from "moment";
import { useMemo } from "react";
import { SWRResponse } from "swr";

export const useErrorProps = <Item,>(response: SWRResponse<Item>) => {
  return useMemo(
    () => ({
      error: response.isLoading || response.isValidating ? undefined : response.error,
      onRetry: response.mutate,
    }),
    [response]
  );
};

export const useGridProps = <Item,>(response: SWRResponse<Array<Item>>) => {
  return useMemo(
    () => ({
      loading: response.isLoading || response.isValidating,
      rows: (response.data || ([] as Item[])).map((p, i) => ({
        ...p,
        orig_id: (p as any).id ? (p as any).id : undefined,
        id: i,
      })),
    }),
    [response.isLoading, response.isValidating, response.data]
  );
};

type LoadingOverlayInfo = {
  sx?: SxProps<Theme>;
  loadingOverlay: React.JSXElementConstructor<any>;
};

export const useGridLoadingOverlay = (isLoading: boolean, pageSize?: number): LoadingOverlayInfo => {
  return useMemo<LoadingOverlayInfo>(
    () => ({
      sx: pageSize ? { height: 72 + 67 * (pageSize ?? 5) } : undefined,
      loadingOverlay: isLoading ? () => <SkeletonLoadingOverlay pageSize={pageSize} /> : LinearProgress,
    }),
    [isLoading, pageSize]
  );
};

export type GridPaginationProps = {
  pagination: boolean;
  paginationModel?: GridPaginationModel;
  hideFooter?: boolean;
};

export const formatDateTime = (dateTime: string) => moment(dateTime).format(playerPageDateFormat);
